/**
 * 매일 콘텐츠 (DEV_SPEC 4.6, v1.1). 서버와 클라이언트가 함께 쓰는 단일 원본입니다.
 *
 * kind 는 daily_items.kind 와 notification_prefs.kind 의 값입니다.
 * 시각은 KST. scope 가 user 면 유저마다 따로 걸리고(운세는 사주가 없으면 일진 공통으로), global 이면 공용 한 번입니다.
 * defaultNotify 는 알림의 기본값입니다(운세·한 문장·체크인 켜짐, 오늘의 한 수 꺼짐).
 */
export const DAILY_KINDS = {
    fortune: {
        kind: 'fortune',
        name: '오늘의 운세',
        memberKey: 'imo',
        time: '07:30',
        scope: 'user',
        defaultNotify: true,
        notice: '운세는 재미로 봐 주세요.',
    },
    sentence: {
        kind: 'sentence',
        name: '니체의 한 문장',
        memberKey: 'oreum',
        time: '08:00',
        scope: 'global',
        defaultNotify: true,
    },
    daily_move: {
        kind: 'daily_move',
        name: '오늘의 한 수',
        // 담당은 요일마다 바뀝니다 (DAILY_MOVES)
        memberKey: null,
        time: '12:30',
        scope: 'global',
        defaultNotify: false,
    },
    checkin: {
        kind: 'checkin',
        name: '오늘 어땠어',
        memberKey: 'imo',
        time: '21:00',
        scope: 'user',
        defaultNotify: true,
    },
};

export const DAILY_KIND_KEYS = Object.keys(DAILY_KINDS);

/**
 * 오늘의 한 수 요일 순환 (DEV_SPEC 4.6). 인덱스는 Date.getDay() 와 같습니다(0 = 일요일).
 * commenterKey 는 한 줄 댓글을 다는 맞수 멤버입니다(손 팀장 ↔ 도 대표, 은별 ↔ 오름).
 */
export const DAILY_MOVES = [
    { weekday: 0, title: '한 주를 닫는 노래', memberKey: 'oreum', commenterKey: 'eunbyeol', basis: '니체' },
    { weekday: 1, title: '이번 주 작전', memberKey: 'son', commenterKey: 'do', basis: '손자병법' },
    { weekday: 2, title: '장사 한 줄', memberKey: 'do', commenterKey: 'son', basis: '범려·『사기』 화식열전' },
    { weekday: 3, title: '이번 주 하늘', memberKey: 'eunbyeol', commenterKey: 'oreum', basis: '노스트라다무스 형식' },
    { weekday: 4, title: '협상 한 수', memberKey: 'son', commenterKey: 'do', basis: '손자병법' },
    { weekday: 5, title: '돈 습관 점검', memberKey: 'do', commenterKey: 'son', basis: '범려' },
    { weekday: 6, title: '주말의 향', memberKey: 'eunbyeol', commenterKey: 'oreum', basis: '조향' },
];

/**
 * 이모의 주간 편지 (DEV_SPEC 4.14 4항, 사용자 결정 2026-10-13: 일요일 19:00 상회칠판 칸, D54).
 * 매일 콘텐츠(DAILY_KINDS)와 따로 둡니다(알림 종류가 아님). 이번 주 별채 일 두 개 + 다음 주 예고 하나, 3줄 이내, 공용
 */
export const WEEKLY_LETTER = {
    kind: 'weekly_letter',
    name: '이모의 주간 편지',
    memberKey: 'imo',
    time: '19:00',
    weekday: 0,
};

/** 도 대표 글에는 늘 붙입니다 (DEV_SPEC 4.6) */
export const NO_INVEST_NOTICE = '종목이나 코인은 추천하지 않아요.';

/** 'YYYY-MM-DD'(서울 날짜)의 오늘의 한 수 */
export function dailyMoveOf(dateText) {
    const [year, month, day] = dateText.split('-').map(Number);
    return DAILY_MOVES[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
}

/** 유저 리액션 3종 (DEV_SPEC 4.2, D15). 매일 콘텐츠 글에만 남깁니다 */
export const REACTIONS = [
    { kind: 'empathy', label: '공감' },
    { kind: 'comfort', label: '위로' },
    { kind: 'cheer', label: '응원' },
];

export const REACTION_KINDS = REACTIONS.map((reaction) => reaction.kind);
